// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__hjbPI","errors":"Errors_errors__my8M0"};